export const ALL_SECTIONS = [
  { key: 'rentals',      label: 'Rentals',          desc: 'View & manage active rentals' },
  { key: 'calendar',     label: 'Calendar',          desc: 'View & edit booking calendar' },
  { key: 'incoming',     label: 'Incoming Bookings', desc: 'Confirm/decline online bookings' },
  { key: 'map',          label: 'Live Map',          desc: 'Track vehicles and view POIs' },
  { key: 'fleet',        label: 'Fleet & Pricing',   desc: 'Add/edit vehicles and prices' },
  { key: 'maintenance',  label: 'Maintenance',       desc: 'Log and view service records' },
  { key: 'damages',      label: 'Damages',           desc: 'Report and track vehicle damages' },
  { key: 'history',      label: 'Rental History',    desc: 'View completed rental records' },
  { key: 'invoices',     label: 'Pro Formas',        desc: 'Create and manage pro forma documents' },
  { key: 'revenue',      label: 'Revenue',           desc: 'View financial reports' },
  { key: 'customers',    label: 'Customers',         desc: 'View and edit customer profiles' },
  { key: 'bookingsetup', label: 'Booking Page',      desc: 'Configure the online booking page' },
  { key: 'agreement',    label: 'Agreements',        desc: 'Create and sign agreements' },
  { key: 'emailtemplates', label: 'Email Templates', desc: 'Customize customer emails' },
  { key: 'roles',        label: 'Users & Roles',     desc: 'Manage team and permissions' },
  { key: 'settings',     label: 'Company Settings',  desc: 'Branding, Stripe, invoice setup' },
];

const allPerms = ALL_SECTIONS.reduce((o, s) => ({ ...o, [s.key]: { view: true, edit: true } }), {});

export const initialRoles = [
  {
    id: 'admin',
    name: 'Admin',
    color: '#C8401E',
    colorLight: '#FAF0ED',
    desc: 'Full access to everything',
    perms: allPerms,
    locked: true,
  },
  {
    id: 'manager',
    name: 'Manager',
    color: '#1C5FAD',
    colorLight: '#EBF2FC',
    desc: 'Full operations, no billing or settings',
    perms: {
      rentals:      { view: true,  edit: true  },
      calendar:     { view: true,  edit: true  },
      incoming:     { view: true,  edit: true  },
      fleet:        { view: true,  edit: false },
      maintenance:  { view: true,  edit: true  },
      damages:      { view: true,  edit: true  },
      history:      { view: true,  edit: false },
      invoices:     { view: true,  edit: false },
      revenue:      { view: true,  edit: false },
      customers:    { view: true,  edit: true  },
      bookingsetup: { view: false, edit: false },
      agreement:    { view: true,  edit: true  },
      roles:        { view: false, edit: false },
      map:          { view: true,  edit: false },
      settings:     { view: false, edit: false },
    },
  },
  {
    id: 'driver',
    name: 'Driver',
    color: '#1A7A4A',
    colorLight: '#EAF5EF',
    desc: 'View own assigned rentals and calendar only',
    perms: {
      rentals:      { view: true,  edit: false },
      calendar:     { view: true,  edit: false },
      incoming:     { view: false, edit: false },
      fleet:        { view: false, edit: false },
      maintenance:  { view: false, edit: false },
      damages:      { view: false, edit: false },
      history:      { view: false, edit: false },
      invoices:     { view: false, edit: false },
      revenue:      { view: false, edit: false },
      customers:    { view: false, edit: false },
      bookingsetup: { view: false, edit: false },
      agreement:    { view: true,  edit: false },
      roles:        { view: false, edit: false },
      map:          { view: false, edit: false },
      settings:     { view: false, edit: false },
    },
  },
  {
    id: 'mechanic',
    name: 'Mechanic',
    color: '#B8720A',
    colorLight: '#FDF4E3',
    desc: 'View fleet and log maintenance only',
    perms: {
      rentals:      { view: false, edit: false },
      calendar:     { view: true,  edit: false },
      incoming:     { view: false, edit: false },
      fleet:        { view: true,  edit: false },
      maintenance:  { view: true,  edit: true  },
      damages:      { view: true,  edit: true  },
      history:      { view: false, edit: false },
      invoices:     { view: false, edit: false },
      revenue:      { view: false, edit: false },
      customers:    { view: false, edit: false },
      bookingsetup: { view: false, edit: false },
      agreement:    { view: false, edit: false },
      roles:        { view: false, edit: false },
      map:          { view: false, edit: false },
      settings:     { view: false, edit: false },
    },
  },
  {
    id: 'operator',
    name: 'Operator',
    color: '#0E7490',
    colorLight: '#ECFEFF',
    desc: 'Check-in/check-out only — sees assigned bookings',
    perms: {
      rentals:      { view: true,  edit: true  },
      calendar:     { view: true,  edit: false },
      incoming:     { view: false, edit: false },
      fleet:        { view: false, edit: false },
      maintenance:  { view: false, edit: false },
      damages:      { view: true,  edit: true  },
      history:      { view: false, edit: false },
      invoices:     { view: false, edit: false },
      revenue:      { view: false, edit: false },
      customers:    { view: false, edit: false },
      bookingsetup: { view: false, edit: false },
      agreement:    { view: false, edit: false },
      roles:        { view: false, edit: false },
      map:          { view: false, edit: false },
      settings:     { view: false, edit: false },
    },
  },
  {
    id: 'accountant',
    name: 'Accountant',
    color: '#5B3E9E',
    colorLight: '#F0EBFC',
    desc: 'Finance only — invoices, revenue, no operations',
    perms: {
      rentals:      { view: true,  edit: false },
      calendar:     { view: false, edit: false },
      incoming:     { view: false, edit: false },
      fleet:        { view: false, edit: false },
      maintenance:  { view: false, edit: false },
      damages:      { view: true,  edit: false },
      history:      { view: true,  edit: false },
      invoices:     { view: true,  edit: true  },
      revenue:      { view: true,  edit: false },
      customers:    { view: true,  edit: false },
      bookingsetup: { view: false, edit: false },
      agreement:    { view: false, edit: false },
      roles:        { view: false, edit: false },
      map:          { view: false, edit: false },
      settings:     { view: false, edit: false },
    },
  },
];

export const initialUsers = [
  { id: 'u1', fname: 'Vaggelis', lname: 'G.', email: 'vaggelis@fleetrent.cy', phone: '+357 99 000 001', roleId: 'admin',      status: 'active',  lastActive: 'Now',        initials: 'VG', color: '#C8401E' },
  { id: 'u2', fname: 'Andreas',  lname: 'P.', email: 'andreas@fleetrent.cy',  phone: '+357 99 111 222', roleId: 'manager',    status: 'active',  lastActive: '2h ago',     initials: 'AP', color: '#1C5FAD' },
  { id: 'u3', fname: 'Kostas',   lname: 'D.', email: 'kostas@fleetrent.cy',   phone: '+357 99 333 444', roleId: 'driver',     status: 'active',  lastActive: 'Yesterday',  initials: 'KD', color: '#1A7A4A' },
  { id: 'u4', fname: 'Maria',    lname: 'S.', email: 'maria@fleetrent.cy',    phone: '+357 99 555 666', roleId: 'accountant', status: 'active',  lastActive: '3 days ago', initials: 'MS', color: '#5B3E9E' },
  { id: 'u5', fname: 'Nikos',    lname: 'T.', email: 'nikos@fleetrent.cy',    phone: '+357 99 777 888', roleId: 'mechanic',   status: 'invited', lastActive: 'Not yet',    initials: 'NT', color: '#B8720A' },
];
